import { createFileRoute } from '@tanstack/react-router';
import { PersonalizacoesConsultasPage } from '@/features/comando-sql/page/PersonalizacoesConsultasPage';

export const Route = createFileRoute('/a/personalizacoes/consultas')({
    component: PersonalizacoesConsultasPage,
});
